import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";

export const getAllBookingReference = createAsyncThunk(
  "Website/FindAllBookingReference",
  async (formdata: { Skip: number; Limit: number; RoomName?: string }) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Website/FindAllBookingReference`,
        formdata
      );
      return response.data?.Data || [];
    } catch (error: any) {
      console.error("Error Fetching Booking Reference:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
